<mat-card class="card">
  @if (editMode) {
  <mat-card-title mat-dialog-title i18n>Edit</mat-card-title>
  } @if (!editMode) {
  <mat-card-title mat-dialog-title i18n>Enter New</mat-card-title>
  }

  <mat-card-content>
    <form [formGroup]="conditionForm">
      <div class="flex-col space-between-none">
        <mat-form-field appearance="outline">
          <mat-label i18n>Expression</mat-label>
          <input matInput formControlName="expression" />
        </mat-form-field>
        <mat-checkbox
          formControlName="oneArgument"
          (change)="onOneArgChange($event)"
          i18n
          >One argument</mat-checkbox
        >
        <mat-radio-group
          class="flex-row space-around-none"
          formControlName="operator"
        >
          <mat-radio-button
            class="app-devices-radio"
            [value]="+TableFieldConditionOp.OR"
            >OR</mat-radio-button
          >
          <mat-radio-button
            class="app-devices-radio"
            [value]="+TableFieldConditionOp.AND"
            >AND</mat-radio-button
          >
        </mat-radio-group>
        <div class="flex-row space-between-none">
          <div formGroupName="argument1" class="app-arg-box">
            <mat-label>Argument 1</mat-label>
            <mat-form-field appearance="outline">
              <mat-label i18n="@@value">Value</mat-label>
              <input matInput formControlName="value" />
            </mat-form-field>
            <mat-form-field>
              <mat-label i18n="@@argumentOpertaop">operator</mat-label>
              <mat-select formControlName="operator">
                @for (type of TableFiledConditionOpMap | keyvalue; track type) {
                <mat-option [value]="+type.key">{{ type.value }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div
            formGroupName="argument2"
            class="app-arg-box"
            [style]="{
              'background-color': conditionForm.controls.oneArgument.value
                ? 'lightgray'
                : ''
            }"
          >
            <mat-label>Argument 2</mat-label>
            <mat-form-field appearance="outline">
              <mat-label i18n="@@value">Value</mat-label>
              <input
                [readonly]="conditionForm.controls.oneArgument.value"
                matInput
                formControlName="value"
              />
            </mat-form-field>
            <mat-form-field
              [style]="{
                background: conditionForm.controls.oneArgument.value
                  ? 'lightgray !important'
                  : ''
              }"
            >
              <mat-label i18n="@@argumentOpertaop">operator</mat-label>
              <mat-select formControlName="operator">
                @for (type of TableFiledConditionOpMap | keyvalue; track type) {
                <mat-option [value]="+type.key">{{ type.value }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex-row space-between-none">
          <mat-form-field appearance="outline">
            <mat-label i18n>True Result</mat-label>
            <input matInput formControlName="resultTrue" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label i18n>False Result</mat-label>
            <input matInput formControlName="resultFalse" />
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="flex-row end-center gap-20" mat-dialog-actions>
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="elevated"
        color="accent"
        (click)="onSave()"
        [disabled]="!conditionForm.valid || conditionForm.pristine"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </div>
  </mat-card-actions>
</mat-card>
